import { formatRelativeTime } from '../../_utilities/relative-time'

const buildStamp = (generatedAt: number | null): string => {
  if (generatedAt === null) {
    return ''
  }

  return `Refreshed ${formatRelativeTime(generatedAt)}`
}

export { buildStamp }
